import React from "react";

import { CorporationInsuranceFilters } from './CorporationInsuranceFilters';

export const CorporationInsurance = (props) => {
  const { init_corporation, insurances } = props;

  return (
    <>
      <CorporationInsuranceFilters
        corporation_id={init_corporation.id}
        insurances={insurances}
        using_insurance_ids={init_corporation.using_insurance_ids} />
    </>
  );
};